import { render, staticRenderFns } from "./Radio.dynamic.vue?vue&type=template&id=3345ef12&"
import script from "./Radio.dynamic.vue?vue&type=script&lang=js&"
export * from "./Radio.dynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports